import * as React from 'react'
import * as ReactDom from 'react-dom'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { CPInstructorMethods } from '../../typescript/CalcPad/Helpers/CPInstructorMethods';
import { CPMethods } from '../../typescript/CalcPad/Helpers/CPMethods';
import { GlobalMethods } from '../../typescript/Global/Helpers/GlobalMethods';
import AssignmentBuilder, { AssignmentBuilderProps } from './components/AssignmentBuilder';
import AssignmentDisplay from './components/AssignmentDisplay';
import ProblemBuilder from './components/ProblemBuilder';
import ProblemDisplay from './components/ProblemDisplay';
import StudentAssignment from './components/StudentAssignment'
import { CPAssignment, CPAssignmentDisplay } from './models/CPAssignment';
import { CPProblem, CPProblemDisplay } from './models/CPProblem';
import Toastify from 'toastify-js'
import ProblemSearchComponent from './components/ProblemSearchComponent';

export class CPReactMethods {
    public launchProblemDisplay(container: HTMLDivElement, data: CPProblemDisplay, courseGuid?: string) {
        const root = createRoot(container)
        root.render(<ProblemDisplay isSubmittable={true} problem={data} isPreview={true} isPublic={false} problemIndex={0} displayProblem={true} canSubmitLate={false} />)
    }
    public launchProblemDisplayPublic(container: HTMLDivElement, data: CPProblemDisplay, courseGuid?: string) {
        const root = createRoot(container)
        root.render(<ProblemDisplay isSubmittable={true} problem={data} isPreview={true} isPublic={true} problemIndex={0} displayProblem={true} canSubmitLate={false} />)
    }
    public launchAssignmentDisplay(container: HTMLDivElement, data: CPAssignmentDisplay) {
        const root = createRoot(container)
        root.render(<AssignmentDisplay assignment={data} />)
    }

    public launchAssignmentBuilder(container: HTMLDivElement, assignment: CPAssignment, helpText: string, limitedEditing: boolean, isSharedAssignment: boolean, problemLimitEditing: Record<number, boolean>, problemUserIsOwner: Record<number, boolean>, problemInMultiplePlaces: Record<number, boolean>, problemAnsweredInAssignment: Record<number, boolean>, courseGuid?: string) {
        const root = createRoot(container)
        root.render(<AssignmentBuilder assignment={assignment} helpTextHtml={helpText} limitedEditing={limitedEditing} isSharedAssignment={isSharedAssignment} problemLimitEditing={problemLimitEditing} problemUserIsOwner={problemUserIsOwner} problemInMultiplePlaces={problemInMultiplePlaces} problemAnsweredInAssignment={problemAnsweredInAssignment} courseGuid={courseGuid} />)
    }

    public launchProblemBuilder(container: HTMLDivElement, problem: CPProblem, userIsOwner: boolean, limitEditing: boolean, inMultiplePlaces: boolean, standAloneProblem: boolean) {
        const root = createRoot(container)
        root.render(<ProblemBuilder problem={problem} userIsOwner={userIsOwner} limitEditing={limitEditing} inMultiplePlaces={inMultiplePlaces} standAloneProblem={standAloneProblem} />);
    }

    public launchProblemLibrary(container: HTMLDivElement, topic: string) {
        const root = createRoot(container)
        root.render(<ProblemSearchComponent isProblemLibrary={true} selectedTopic={topic} />)
    }

    public static isNullOrUndefined(value: any): boolean {
        return typeof (value) === "undefined" || value == null;
    }

    public static isNullOrWhiteSpace(value: string | undefined | null) {
        return typeof (value) === "undefined" || value == null || value.trim().length == 0;
    }
}


// declare my helper in the window interface
declare global {
    interface Window {
        CPReactMethods: CPReactMethods,
        CPInstructor: CPInstructorMethods,
        CPMethods: CPMethods,
        GlobalMethods: GlobalMethods,
        toasts: Record<string, Toastify>
    }
}

// Can access your methods with window.SiteMethods.theMethodName()
window.CPReactMethods = new CPReactMethods();
window.CPMethods = new CPMethods();
window.CPInstructor = new CPInstructorMethods();
window.GlobalMethods = new GlobalMethods();
window.toasts = window.toasts || {} as Record<string, Toastify>;